import React from 'react';
import { PropTypes } from 'prop-types';
// logic
import { useTranslation } from 'react-i18next';
// state
import { useSelector } from 'react-redux';
import { selectors as settingsSelectors } from 'state/settings';
// styles
import styled, { css } from 'styled-components';
import { media } from 'utils/style';
// components
import { Button } from '@ontruck/orc';
import useNewOrderButton from 'refactored/ui/nav/useNewOrderButton';
import { IS_TENANT } from 'tenant/utils';

const NewShipmentButton = ({ className }) => {
  const { t } = useTranslation('Orders');

  const { country } = useSelector(settingsSelectors.getCountrySettings);

  const { onNewOrderButtonClick } = useNewOrderButton();

  if (country === 'UK' || IS_TENANT) return <></>;
  return (
    <div className={className}>
      <Button onClick={onNewOrderButtonClick}>{t('new_order')}</Button>
    </div>
  );
};

NewShipmentButton.propTypes = {
  className: PropTypes.string,
};

const regularCSS = css`
  display: none;
  padding: 8px;
  background-color: var(--white);
  border-top: 1px solid var(--grey200);
  button {
    width: 100%;
    text-transform: uppercase;
    font-size: 16px;
  }
`;

const mobileCSS = css`
  display: flex;
`;

export default styled(NewShipmentButton)`
  ${regularCSS}
  ${media.lessThan('small')`${mobileCSS}`}
`;
